import {styled, Tooltip, tooltipClasses, TooltipProps} from "@mui/material";

type CustomTooltipProps = Omit<TooltipProps, "arrow">;

const CustomTooltip = ({
	placement = "top",
	children,
	...props
}: CustomTooltipProps) => (
	<CustomWidthTooltip placement={placement} arrow {...props}>
	  	{children}
	</CustomWidthTooltip>
);

const CustomWidthTooltip = styled(({className, ...props}: TooltipProps) => (
	<Tooltip {...props} classes={{popper: className}} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 400
	}
});

export default CustomTooltip;